
<template>
  <div id="page-data-view">

    <vx-card title="User Role Details" class="mb-base">

      <div class="vx-row">

        <!-- Information - Col 1 -->
        <div class="vx-col flex-1" id="account-info-col-2">
          <table>
            <tr>
              <td class="font-semibold">Name</td>
              <td>{{ view_data.name }}</td>
            </tr>
          </table>
        </div>
        <!-- /Information - Col 1 -->

        <!-- /Information - Col 2 -->
        <div class="vx-col flex-1" id="account-info-col-1">
          <table>
            <tr>
              <!-- <td class="font-semibold">Property</td>
              <td v-if="view_data.property !== null">{{ view_data.property.name }}</td> -->
              <td class="font-semibold">Description</td>
              <td>{{ view_data.description }}</td>
            </tr>
          </table>
        </div>
        <!-- /Information - Col 2 -->



        <div class="vx-col w-full flex" id="account-manage-buttons">
          <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{name: 'app-role-edit', params: { editId: $route.params.viewId }}" 
            :disabled="!showU">Edit <!-- crud -->
            </vs-button> 
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord" 
            :disabled="!showD">Delete <!-- crud -->
            </vs-button>
        </div>
      </div>
    </vx-card>

    <!-- Permissions -->
    <vx-card title="Permission" class="mb-base">
        <table class="w-full">
          <tr>
            <th class="font-semibold text-base text-left px-3 py-2" v-for="heading in ['Module','Menu', 'Create', 'Read', 'Update', 'Delete']" :key="heading">{{ heading }}</th>
          </tr>

          <tr v-for="(val, id) in optionUserModule" v-if="edit_data[val.val] === undefined ? checkM(val.val) : true">
            <td class="px-3 py-2">{{ val.name }}</td>
            <td class="px-3 py-2">
              <vs-checkbox v-model="edit_data[val.val]['list']" disabled></vs-checkbox>
            </td>
            <td class="px-3 py-2">
              <vs-checkbox v-model="edit_data[val.val]['create']" disabled></vs-checkbox>
            </td>
            <td class="px-3 py-2">
              <vs-checkbox v-model="edit_data[val.val]['read']" disabled></vs-checkbox>
            </td>
            <td class="px-3 py-2">
              <vs-checkbox v-model="edit_data[val.val]['update']" disabled></vs-checkbox>
            </td>
            <td class="px-3 py-2">
              <vs-checkbox v-model="edit_data[val.val]['delete']" disabled></vs-checkbox>
            </td>
          </tr>
        </table>
    </vx-card>

    <vx-card title="User Sub Role" class="mb-base">
      <list-tab class="mt-4" />
    </vx-card>      

    <vs-alert color="danger" title="Data Not Found" :active.sync="data_not_found">
      <span>Data record with id: {{ $route.params.viewId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'app-role-list'}" class="text-inherit underline">All Data</router-link>
      </span>
    </vs-alert>

  </div>
</template>

<script>
import axios from '@/axios'
import mainHelper from '@/mainHelper' //crud
import ListTab from './list/List.vue'

export default {
  components: {
    ListTab
  },
  data () {
    const token = localStorage.usertoken
    return {
      // crud
      showL: false,
      showC: false,
      showR: false,
      showU: false,
      showD: false,
      token: token,

      optionUserModule: [],
      edit_data: [],
      
      //role
      view_data: {
        parent_id: '',
        property_id: '',
        property: {
          name: ''
        },        
        name: ''
      },
      data_not_found: false
    }
  },
  computed: {
  },
  methods: {
    checkM(data) {
      return new Promise((resolve, reject) => {
        try {
          this.edit_data[data]  = {
            all: false,
            list: false,
            create: false,
            update: false,
            read: false,
            delete: false,
          }

          resolve(this.edit_data)
        } catch(err) {
          reject(err.toString('utf8'));
        }
      })
      
      console.log('this.edit_data ', this.edit_data)
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.view_data.email}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      const viewId = this.$route.params.viewId
      var d = new Promise(async(resolve, reject)  => {
        try {    
          await axios.post(`/role/delete/${viewId}`, {
              token: this.token
            })
            .then(res => {        
              if(res['data'] == 'access_denied' || res['data'] == '') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
              } else {
                this.$router.push({name:'app-role-list'})
                this.showDeleteSuccess()
              }

            })
            .catch(err => {              
              reject(err)
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }      

        d.then((res) => {
          this.data_local = res[0]
        })
      })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Data Deleted',
        text: 'The selected data was successfully deleted'
      })
    },
    fetch_view_data (viewId) {
      var d = new Promise(async(resolve, reject)  => {
        try {    
          await axios.get(`/permission/view/${viewId}`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {
              if(res['data'] == 'access_denied' || res['data'] == '') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                this.$router.push({name:'app-permission-list'})
              } else {
                resolve(res['data'])
              }

              this.$vs.loading.close()
            })
            .catch(err => {
              this.$vs.loading.close()
              reject(err)
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }      

        d.then((res) => {
          if(typeof res[0] == 'undefined') {
            this.data_not_found = true
          } else {            
            // for (const i in res) {
            //   var umi = res[i]['user_module_id']
            //   this.edit_data[umi] = res[i]
            //   console.log('res ', res[i])
            // }

            this.edit_data  = JSON.parse(res[0]['permissions_json'])
            
            console.log('res edit d ', res)
          }
        }).catch(err => {
          if (err.response.status === 404) {
            this.edit_not_found = true
            return
          }
          reject(err) 
        })

      })
    },
    loadData () {
      const viewId = this.$route.params.viewId
      var d = new Promise(async(resolve, reject)  => {
        try {    
          await axios.get(`/role/view/${viewId}`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              if(res['data'] == 'access_denied' || res['data'] == '') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                this.$router.push({name:'app-role-list'})
              } else {
                console.log('res d ', res['data'])
                resolve(res['data'])
              }

              this.$vs.loading.close()
            })
            .catch(err => {
              this.data_not_found = true
              this.$vs.loading.close()
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }      

        d.then((res) => {
          this.view_data = res[0]
        })
      })
    },
    loadUserModule () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/userModule/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res user module ', res)
        this.optionUserModule = res

        for (var data in res) {
          var user_module_id = res[data]['id']

          console.log('user_module_id ', user_module_id)

          // this.data_local_p[user_module_id] = {
          //   user_module_id: user_module_id,
          //   list: false,
          //   create: false,
          //   update: false,
          //   read: false,
          //   delete: false,
          // }
          
         
        }

      })
    }
  },
  async created () {
    // crud
    this.showL = await mainHelper.cansee('role-list', 'list')
    this.showC = await mainHelper.cansee('role-create', 'create')
    this.showR = await mainHelper.cansee('role-read', 'read')
    this.showU = await mainHelper.cansee('role-update', 'update')
    this.showD = await mainHelper.cansee('role-delete', 'delete')

    if (!this.showR) {
      this.$vs.notify({
        color: 'danger',
        title: 'Loading Page',
        text: 'You are not authorized to view this page.'
      })
      this.$router.push('/dashboard/analytics')
    }

    this.fetch_view_data(this.$route.params.viewId)
    this.loadData()
    this.loadUserModule()
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-data-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

.avatar-img {
  position: relative;
  width: 230px;
  overflow: hidden;
  padding-top: 230px;
}

.avatar-img img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
}

</style>
